import { Building2 } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import type { MentionSuggestion } from '@/components/mentions/mention-state';

interface MentionMenuProps {
  items: MentionSuggestion[];
  activeIndex: number;
  onSelect: (item: MentionSuggestion) => void;
}

export function MentionMenu({ items, activeIndex, onSelect }: MentionMenuProps) {
  return (
    <div className="max-h-60 w-full overflow-y-auto rounded-xl border border-border bg-white text-foreground shadow-[0_8px_24px_rgba(0,0,0,0.14)] dark:border-zinc-700 dark:bg-black dark:text-neutral-100 dark:shadow-[0_8px_24px_rgba(0,0,0,0.45)]">
      {items.map((item, index) => (
        <button
          key={
            item.trigger === 'at'
              ? `${item.kind}-${item.id}`
              : `${item.kind}-${item.category}-${item.subCategory}`
          }
          type="button"
          className={cn(
            'flex w-full items-center gap-3 px-3 py-2 text-left text-sm font-bold',
            index === activeIndex && 'ring-1 ring-inset ring-primary',
            item.trigger === 'at' &&
              item.kind === 'business' &&
              'bg-violet-50 dark:bg-violet-500/15',
            item.trigger === 'hash' && item.kind === 'category' && 'bg-blue-50 dark:bg-blue-500/15',
            item.trigger === 'hash' &&
              item.kind === 'subcategory' &&
              'bg-amber-50 dark:bg-amber-500/15'
          )}
          onMouseDown={(event) => {
            event.preventDefault();
            onSelect(item);
          }}
        >
          {item.trigger === 'at' && item.kind === 'member' ? (
            <Avatar className="h-8 w-8 shrink-0 rounded-full border-2 border-background">
              {item.image ? (
                <AvatarImage src={item.image} className="rounded-full object-cover" />
              ) : null}
              <AvatarFallback className="rounded-full text-xs">
                {item.label.slice(0, 2).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ) : null}
          {item.trigger === 'at' && item.kind === 'business' ? (
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border-2 border-background bg-violet-100 text-violet-700 dark:border-zinc-800 dark:bg-violet-500/20 dark:text-violet-200">
              <Building2 className="h-4 w-4" />
            </span>
          ) : null}
          <span className="min-w-0 truncate">{item.label}</span>
        </button>
      ))}
    </div>
  );
}
